// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UhJN","question":"styles_question__5Mlsy","inputVisibleButton":"styles_inputVisibleButton__37OMM","note":"styles_note__3CVLV"};